// A vendor's change to what a buyer sees of a product on sale — its name, type, price, pictures — waits for
// review (API catalog lib/product-changes): the product stays on sale as it is, the change is kept apart and
// applied once a reviewer approves it. The write that opened the change set answers `sentForReview`, every
// one of them what the set holds now (`reviewChanges`). Said once, however many writes one save makes; the
// editor takes the set's chips at once (the review state under the dialog's title).
import { showNotification } from "aldoo-ra/Notification"

let lastNotice = 0

/** `answer`: what a write answered; `t`: the host's texts; `editor`: the catalog editor, when there is one. */
export function noticeSentForReview(answer, t, editor) {
  const changes = answer?.reviewChanges || answer?.changes
  if (Array.isArray(changes) && (answer?.inReview || answer?.sentForReview || !changes.length)) editor?.adopt?.("reviewChanges", changes)
  // the set's state (waiting, or back with the vendor and why)
  const change = answer?.reviewChange !== undefined ? answer.reviewChange : answer?.change
  if (change !== undefined) editor?.adopt?.("reviewChange", change)
  if (!answer?.sentForReview) return false
  if (Date.now() - lastNotice < 3000) return true
  lastNotice = Date.now()
  showNotification({ message: t`Your changes have been sent for review`, className: "bg-admin_primary text-white" })
  return true
}
